import { UpdateRule } from '../useCreateDataValidation';
import RuleConditionInputs from '../atoms/RuleConditionInputs';
import {
  ValidationCriteria,
  ValidationRule,
} from '../../../../../../sheet/types';
import IconSetEditor from '../atoms/IconSetEditor';

interface RuleInputsProps {
  rule: ValidationRule;
  updateRule: UpdateRule;
}
const RuleInputs = ({ rule, updateRule }: RuleInputsProps) => {
  switch (rule.criteria) {
    case ValidationCriteria.CellRange:
    case ValidationCriteria.List:
      return <></>;
    case ValidationCriteria.Number:
    case ValidationCriteria.TextLength:
    case ValidationCriteria.Date:
    case ValidationCriteria.Text:
      return <RuleConditionInputs rule={rule} updateRule={updateRule} />;
    case ValidationCriteria.IconSets:
      return <IconSetEditor rule={rule} updateRule={updateRule} />;
  }

  return null;
};

export default RuleInputs;
